<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>
  .easy-player-right-menu {
    display: none;
  }
  .user-link{
    color:#409EFF;
    &:hover{
      color:#409EFF;
    }
  }
</style>
